// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/queryAnalysis',
    name: 'QueryAnalysis',
    component: layout,
    redirect: '/queryAnalysis/index',
    meta: {
      title: '问题维度分析',
      icon: 'i-menu:queryAnalysis',
      i18Key: 'router.user.queryAnalysis.title',
      roles: [1]
    },
    sort: 53,
    children: [
      {
        path: 'index',
        name: 'QueryAnalysisIndex',
        component: () => import('@/views/QueryAnalysis/Index.vue'),
        meta: {
          title: '问题维度分析',
          icon: 'queryAnalysis',
          iconIsComponent: true,
          i18Key: 'router.user.queryAnalysis.index',
          roles: [1],
          headerConditions: ['brand', 'timeBtn', 'questionBtn'],
          isAdvanced: true
        }
      }
    ]
  }
]
export default routes
